module.exports = __webpack_public_path__ + "static/img/goods-demo.0bc2e622.png";